import React from 'react'
import Section, { StyledSpan } from './Section'
import { ContactPageNumber } from '../../constants'

const DealerRepSection = ({ navigatePageWithState, globalState, offer, experienceState, dealerReps, canEdit, calculateViewChange }) => {
  const { isAdmin, dealerInfo } = experienceState
  const dealerRepId = globalState.dealerRepId || (dealerInfo ? dealerInfo.dealerRepId || 0 : 0)
  let dealerRepName = null
  let dealerRepPhone = null
  if (!offer) {
    if (isAdmin && dealerReps && dealerRepId) {
      const dealerRep = dealerReps.find(rep => +rep.dealerRepID === +dealerRepId)
      dealerRepName = dealerRep.name
      dealerRepPhone = dealerRep.phone
    } else return null
  } else {
    if (offer.prospect && offer.prospect.dealerRepPhone) {
      const dealerRep = dealerReps && dealerReps.find(rep => +rep.dealerRepID === +dealerRepId)
      dealerRepName = dealerRep ? dealerRep.name : offer.prospect.dealerRepName
      dealerRepPhone = dealerRep ? dealerRep.phone : offer.prospect.dealerRepPhone
    } else {
      if (isAdmin) {
        const dealerRep = dealerReps && dealerReps.find(rep => +rep.dealerRepID === +dealerRepId)
        dealerRepName = dealerRep && dealerRep.name
        dealerRepPhone = dealerRep && dealerRep.phone
      } else return null
    }
  }
  //no information relevant to auction users is on this page.
  canEdit = canEdit && offer && offer.status !== 'AUCTION'

  let uniqueViewStr = 'uniqueViewStr:' + dealerRepName + dealerRepPhone

  const component = (
    <Section title={'Dealer Rep Information'} showEdit={canEdit} onClick={e => navigatePageWithState({ p: ContactPageNumber })}>
      {dealerRepName && (
        <>
          <StyledSpan>Dealer Rep: </StyledSpan>
          {dealerRepName}
          <br />
          <StyledSpan>Dealer Rep Phone: </StyledSpan>
          {dealerRepPhone}
        </>
      )}
    </Section>
  )

  calculateViewChange('dealerRep', uniqueViewStr)

  return component
}

export default DealerRepSection
